export default "__VITE_ASSET__1RwFoKPJ__"